<div
  class="w-screen h-screen flex justify-center items-center flex-col text-center"
>
  <h1
    class="lg:text-4xl md:text-2xl sm:text-base text-base text-primary-900 font-bold px-20 mb-6"
  >
    Bienvenidos al Sistema Integrado de Gestión Digital de Contreras Hnos.
  </h1>

  <p class="px-20">{{ message }}</p>
  <p class="mb-6 px-20 font-bold">¡Muchas gracias!</p>

  <div
    class="rounded-lg bg-gray-200 lg:w-[60vw] md:w-[60vw] sm:w-[90vw] w-[90vw] p-4 shadow-md"
  >
    <c-input
      tipo="password"
      etiqueta="Contraseña"
      placeholder="Ingrese su nueva contraseña"
      [estricto]="true"
      [(valor)]="clave"
      (valido)="claveValid = $event"
    />
    <br />
    <c-input
      tipo="password"
      etiqueta="Repita contraseña"
      placeholder="Repita su nueva contraseña"
      [hardError]="error"
      mensajeError="La clave debe ser idéntica a la primera"
      [(valor)]="repetirClave"
    />

    <div class="flex justify-between items-center mt-6">
      <button
        pRipple
        class="p-2 bg-white text-primary-900 font-bold rounded-md shadow-md"
        (click)="logout()"
      >
        Salir
      </button>
      <button
        pRipple
        class="bg-primary-900 text-white p-2 rounded-md shadow-md"
        (click)="changePassword()"
      >
        Confirmar
      </button>
    </div>
  </div>
</div>

<c-dialog #dialogo />
